import { NodeColumns } from '../table-store';

/**
 * Single source of truth for the human-readable column names shown to users.
 * Values MUST match the TanStack column `header`s in `table.tsx`; that file
 * consumes this map so the names live in exactly one place. Service-only
 * columns without a visible header (id/intent/solutionVersionId/settings) still
 * get a readable name so a validation error that references them is not raw.
 */
export const nodeColumnDisplayNames: Record<NodeColumns, string> = {
  [NodeColumns.id]: 'ID',
  [NodeColumns.nodeNumber]: 'Node #',
  [NodeColumns.order]: 'Order',
  [NodeColumns.nodeType]: 'Node Type',
  [NodeColumns.nodeName]: 'Node Name',
  [NodeColumns.nluDisabled]: 'NLU Disabled?',
  [NodeColumns.nextNodes]: 'Next Node',
  [NodeColumns.message]: 'Message',
  [NodeColumns.richAssetType]: 'Asset Type',
  [NodeColumns.richAssetContent]: 'Asset Content',
  [NodeColumns.answerRequired]: 'Ans Req?',
  [NodeColumns.behaviors]: 'Behaviors',
  [NodeColumns.command]: 'Command',
  [NodeColumns.description]: 'Description',
  [NodeColumns.output]: 'Output',
  [NodeColumns.nodeInput]: 'Node Input',
  [NodeColumns.parameterInput]: 'Parameter Input',
  [NodeColumns.decisionVariable]: 'Decision Variable',
  [NodeColumns.whatsNext]: 'What Next?',
  [NodeColumns.nodeTags]: 'Node Tags',
  [NodeColumns.skillTag]: 'Skill Tag',
  [NodeColumns.variables]: 'Variables',
  [NodeColumns.platformFlag]: 'Platform Flag',
  [NodeColumns.cssClassname]: 'CSS Class Name',
  [NodeColumns.analyticsEvent]: 'Analytics Events',
  [NodeColumns.utterances]: 'Example Phrases',
  [NodeColumns.intent]: 'Intent',
  [NodeColumns.solutionVersionId]: 'Solution Version',
  [NodeColumns.settings]: 'Settings',
};

/**
 * Resolve an internal column key to its user-facing display name.
 * Falls back to the raw key (so unknown/newly-added columns still show
 * something), and to '' for a nullish column.
 */
export const getNodeColumnDisplayName = (colId?: string | null): string => {
  if (!colId) return '';
  return nodeColumnDisplayNames[colId as NodeColumns] ?? colId;
};
